export default defineNuxtPlugin(() => {
  const logger = useRequestLogger()

  if (import.meta.client) {
    nextTick(() => {
      logger.flushLogs()
    })
  }
})
